import initialState from 'SRC/modules/redux/initialState'
import actionTypes from 'SRC/modules/redux/actionTypes'

export const buyInsurancePolicyReducer = (state = initialState.buyInsurancePolicy, action) => {
  switch (action.type) {
    case actionTypes.SET_INSURANCE_POLICY_FORM_DATA:
      return { ...state, formData: action.payload }
    case actionTypes.SET_INSURANCE_POLICY_QUOTES:
      return { ...state, quotes: action.payload }
    case actionTypes.SET_INSURANCE_POLICY_CHECKOUT_PREVIEW:
      return { ...state, checkoutPreview: action.payload }
    case actionTypes.SET_INSURANCE_POLICY_ORDER_CONFIRMATION:
      return { ...state, orderConfirmation: action.payload }
    case actionTypes.SET_INSURANCE_POLICY_LOADING:
      return { ...state, isLoading: action.payload }
    case actionTypes.SET_INSURANCE_POLICY_ERROR:
      return { ...state, error: action.payload }
    default:
      return state
  }
}
